var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree"},_vm._l((_vm.treeData),function(nodeData,idx){return _c('tree-node',{key:idx,attrs:{"nodeData":nodeData,"id":nodeData.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }